import { useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  NavigationGuardContext,
  type NavigationGuard
} from './navigation-guard-context'

export function NavigationGuardProvider({
  children
}: {
  children: React.ReactNode
}) {
  const navigate = useNavigate()
  const guardsRef = useRef(new Set<NavigationGuard>())

  const registerGuard = useCallback((guard: NavigationGuard) => {
    guardsRef.current.add(guard)
    return () => {
      guardsRef.current.delete(guard)
    }
  }, [])

  const guardedNavigate = useCallback(
    (path: string) => {
      for (const guard of guardsRef.current) {
        if (guard(path)) return
      }
      navigate(path, { viewTransition: true })
    },
    [navigate]
  )

  return (
    <NavigationGuardContext.Provider value={{ registerGuard, guardedNavigate }}>
      {children}
    </NavigationGuardContext.Provider>
  )
}
